import EmptyData from '../../ui/EmptyData';
import ErrorMessage from '../../ui/ErrorMessage'
import Loading from '../../ui/Loading'

export function LoadingProductCart() {
    return (
        <div className="flex justify-center items-center h-full">
            <Loading message="Loading products..." />
        </div>
    )
}

interface ErrorProductCartProps {
    errorMessage: string;
}

export function ErrorProductCart({ errorMessage }: ErrorProductCartProps) {
    return (
        <div className="flex justify-center items-center h-full">
            <ErrorMessage message={errorMessage} />
        </div>
    )
}

export function NoAvailableProductCart() {
    return (
        <div className="flex justify-center items-center h-full">
            <EmptyData message="No products available." />
        </div>
    )
}